import type {LinkedRoleCodeListId} from 'schemaDefinition/types/linkTypes';
import {AllGlobalCodeListIds} from 'schemaDefinition/types/linkTypes';
import type {CodeListId} from '../types';

export const useAllCodeListIds = (): (CodeListId | LinkedRoleCodeListId)[] => {
  return AllGlobalCodeListIds;
};
